import { useEffect } from "react";

export const PHYSIO_SAVE_CONTINUE = "continue";
export const PHYSIO_SAVE_CLOSE = "close";

export default function usePhysioScaleExternalSave({
  triggerSave,
  setTriggerSave,
  saveActionRef,
  op,
  onSave,
}) {
  useEffect(() => {
    if (op) return;
    if (!triggerSave) return;

    const action =
      saveActionRef?.current === PHYSIO_SAVE_CLOSE
        ? PHYSIO_SAVE_CLOSE
        : PHYSIO_SAVE_CONTINUE;
    saveActionRef.current = PHYSIO_SAVE_CONTINUE;

    Promise.resolve(onSave(action)).finally(() => {
      setTriggerSave?.(false);
    });
  }, [triggerSave, op, setTriggerSave, onSave, saveActionRef]);
}
